import React from 'react'
import INCSUBLanding from  '../../components/landing/landing'
import INCSUBFeatures from '../../components/feature/features'
import INCSUBAdvantages from '../../components/advantages/advantages' 
import INCSUBWorking from '../../components/working/working'
import INCSUBQuestions from '../../components/questions/questions'
import INCSUBFooter from '../../components/Footer/Footer'

function INCHomeIndex() {
    return (
        <div>
            <INCSUBLanding />  
            <INCSUBFeatures />
            <INCSUBAdvantages />
            <INCSUBWorking />
            <INCSUBQuestions />
            <INCSUBFooter />
        </div>
    )
}

export default INCHomeIndex
